import React from "react";

export default class Constants extends React.Component {
    static ipAddress = '80.211.39.126/';
    static mainUrl = 'http://fixmeeting.eu/';
    static PdfTitleFontSize = 11;
    static PdfNormalFontSize = 10;
    static PdfFooterFontSize = 9;

}